module.exports = __webpack_public_path__ + "img/KM-360A_04.09e01599.jpg";